import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AssetForm({ setJobId, setLoading, setError }) {
    const [assetCodes, setAssetCodes] = useState('');
    const [localError, setLocalError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isTouched, setIsTouched] = useState(false); // Nuevo estado para saber si el usuario ha interactuado con el campo

    // Validación dinámica cuando el usuario edita los códigos
    useEffect(() => {
        const validateInput = () => {
            // Solo mostrar errores si el usuario ha interactuado con el campo
            if (!isTouched) {
                setLocalError(null);
                return;
            }

            const lines = assetCodes.split('\n').filter(line => line.trim() !== '');
            if (lines.length > 10) {
                setLocalError('Solo puedes introducir un máximo de 10 códigos de UA.');
            } else {
                setLocalError(null); // No hay errores
            }
        };

        validateInput();
    }, [assetCodes, isTouched]); // Ejecutar validación cada vez que assetCodes o isTouched cambien

    const handleSubmit = async (e) => {
        e.preventDefault();

        const lines = assetCodes.split('\n').filter(line => line.trim() !== '');
        if (lines.length === 0) {
            setLocalError('Por favor, introduce al menos un código de UA.');
            return; // Evitar el envío si no hay códigos
        }

        if (lines.length > 10) {
            setLocalError('Solo puedes introducir un máximo de 10 códigos de UA.');
            return; // Evitar el envío si hay más de 10 códigos
        }

        setIsSubmitting(true);
        setLoading(true);

        try {
            const formattedCodes = lines.map(code => code.trim().replace(/\//g, '-'));

            const response = await axios.post(
                'https://macc-apimanagement-cloudservices-pro.azure-api.net/alquizen-docs/api/documents/process',
                { asset_codes: formattedCodes },
                { timeout: 10000 }
            );

            setJobId(response.data.job_id);
        } catch (error) {
            console.error('Error al procesar la solicitud:', error);
            const errorMessage = error.response?.data?.detail || 'Error al procesar la solicitud. Por favor, inténtalo de nuevo.';
            setLocalError(errorMessage);
            setError(errorMessage);
        } finally {
            setIsSubmitting(false);
            setLoading(false);
        }
    };

    return (
        <>
            {localError && (
                <div className="alert alert-danger" role="alert">
                    <strong>Error: </strong>{localError}
                </div>
            )}

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label" htmlFor="assetCodes">
                        <strong>Códigos de UA</strong>
                    </label>
                    <textarea
                        id="assetCodes"
                        className="form-control"
                        placeholder="Introduce los códigos de UA aquí, una UA por línea

                        Ejemplo:
                        2201/22010007/630
                        2201/22010007/631"
                        rows="4"
                        value={assetCodes}
                        onChange={(e) => setAssetCodes(e.target.value)}
                        onFocus={() => setIsTouched(true)} // Marcar como "tocado" cuando el usuario interactúe
                    />
                    <div className="form-text">
                        Formato UA: 2201/22010007/630
                    </div>
                </div>
                <button
                    type="submit"
                    className="button-primary w-100"
                    disabled={isSubmitting || localError !== null}
                >
                    {isSubmitting ? 'Procesando...' : 'Procesar Documentos'}
                </button>
            </form>
        </>
    );
}

export default AssetForm;